// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HmeD","option":"styles_option__2sjG8","selected":"styles_selected__3yhcD"};